import React from "react";
import { twMerge } from "tailwind-merge";

type Props = { children: React.ReactNode; className?: string };
function InputValidationError({ children, className }: Props) {
  return (
    <p className={twMerge("mt-1 text-xs text-red-600", className)}>
      {children}
    </p>
  );
}

export default InputValidationError;
